import React from "react";
import { Avatar, Box, Divider, HStack, Heading, IconButton, Spacer, useBreakpointValue } from "@chakra-ui/react";
import { FiLogOut, FiSearch } from "react-icons/fi";
import { useAuth } from "../auth/AuthProvider";
import { FiMenu } from "react-icons/fi";

const DashboardHeader = ({ heading = "", onOpen }) => {

  const { logout } = useAuth();
  const isMobile = useBreakpointValue({ base: true, md: false });

  const handleLogout = () => {
    logout();
  }

  return (
    <Box boxShadow={'md'}>
      <HStack>
        {isMobile && (
          <IconButton
            icon={<FiMenu />}
            onClick={onOpen}
            aria-label="Open Menu"
            left="1rem"
            zIndex={1000}
          />
        )}
        <Heading fontSize={isMobile ? "xl" : "2xl"} fontWeight={"light"} p="4">
          {heading}
        </Heading>
        <Spacer />
        {/* <IconButton icon={<FiSearch />} variant="ghost" /> */}

        <Avatar size="sm" />
        <IconButton onClick={handleLogout} icon={<FiLogOut />} variant="ghost" />
      </HStack>
      <Divider mb="5" />
    </Box>
  );
};

export default DashboardHeader;
